import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { dismissNotifications as dismissVendorNotifications } from '@/checkout-instore-legacy/vendor/actions'
import { dismissNotifications as dismissOrderNotifications } from '@/checkout-instore-legacy/order/actions'

import Notifier from './Notifier'

const mapStateToProps = (state) => {
  return {
    orderStoreError: state.order.error,
    vendorStoreError: state.vendor.error,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    { dismissOrderNotifications, dismissVendorNotifications },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifier)
